// OP-3605 — Rótulo e cor por status de solicitação (os 11 do domínio).
import { StatusSolicitacao } from '../../../types/estoque'

export const STATUS_SOLICITACAO_UI: Record<StatusSolicitacao, { bg: string; color: string; label: string }> = {
  EM_ANALISE: { bg: '#DBEAFE', color: '#1E40AF', label: 'Em análise' },
  AGUARDANDO_INFO: { bg: '#FEF3C7', color: '#92400E', label: 'Aguardando informação' },
  APROVADA: { bg: '#D1FAE5', color: '#065F46', label: 'Aprovada' },
  EM_SEPARACAO: { bg: '#E0E7FF', color: '#3730A3', label: 'Em separação' },
  EM_ESPERA: { bg: '#FED7AA', color: '#9A3412', label: 'Aguardando transferência' },
  PRONTA: { bg: '#CCFBF1', color: '#115E59', label: 'Pronta' },
  EXPEDIDA: { bg: '#DBEAFE', color: '#1E3A8A', label: 'Expedida' },
  ATENDIDA_PARCIAL: { bg: '#FEF3C7', color: '#92400E', label: 'Atendida em parte' },
  CONCLUIDA: { bg: '#D1FAE5', color: '#065F46', label: 'Concluída' },
  REJEITADA: { bg: '#FEE2E2', color: '#991B1B', label: 'Recusada' },
  CANCELADA: { bg: '#F3F4F6', color: '#374151', label: 'Cancelada' },
}

/** Sem transição possível: espelho de `ehFinal` do domínio. */
export const STATUS_FINAIS: StatusSolicitacao[] = ['CONCLUIDA', 'REJEITADA', 'CANCELADA']
export const ehFinal = (s: StatusSolicitacao): boolean => STATUS_FINAIS.indexOf(s) >= 0
